import React from 'react'

import { Tag } from 'rsuite'
import { formatTextMaterialCategoryStatus } from '@@partner:helpers/formatters/textMaterial'

export interface CustomerStatusLabelProps {
  status: string
}

export default function TextMaterialThemeStatusLabel ({
  status
}: CustomerStatusLabelProps) {
  const { label, color } = formatTextMaterialCategoryStatus(status)
  return (
    <Tag className="u-status-badge" color={color}>
      {label}
    </Tag>
  )
}
